/*
 * Helper class for Actis Reporting.
 *
 */

import { getPageFromUrlForActisTracking, getToolsEnv } from '@utils/Utilities';
import { Constants } from '@constants/Constants';

const APOLLO_STREAM = getToolsEnv() === Constants.TOOLS_ENV.DEMO
  ? 'apollo-demo-firehose' : 'apollo-firehose';

export class ActisReporting {
  constructor(category) {
    this.category = category;
    this.push = this.push.bind(this);
  }

  // allow this to pass a event category
  push(obj) {
    if (window.pushEvent) {
      this.binder = this.__proto__.binder;
      window.pushEvent(
        {
          ...obj,
          category: this.category,
          userId: this.binder.userId || "",
          firstName: this.binder.firstName || "",
          lastName: this.binder.lastName || "",
          email: this.binder.email || "",
          companyName: this.binder.companyName || "",
          orgId: this.binder.orgId || "",
          userType: this.binder.role || "",
          toolsOrgId: this.binder.toolsOrgId || "",
          page: getPageFromUrlForActisTracking() || "",
        },
        APOLLO_STREAM
      );
    }
  }
}

export const ACTIS_REPORTING = {
  BINDER: null,
  PRIMARY_LOGO: new ActisReporting("Gartner Logomark"),
  SECONDARY_LOGO: new ActisReporting("Third-Party Cyber Risk Platform"),
  APP_LOAD: new ActisReporting("Third-Party Cyber Risk Login"),
  HELP: new ActisReporting("Help"),
  SEARCH: new ActisReporting("Search for Vendor"),
  INVITE_VENDOR: new ActisReporting("Invite Vendor"),
  PROFILE_MANAGE_TEAM: new ActisReporting('Profile - Manage Team'),
  NOTIFICATION_BELL: new ActisReporting('Alerts Bell icon on header'),
  NOTIFICATION_CTA: new ActisReporting('CTA in Notification clicked'),
  ADD_UNKNOWN_VENDOR_CTA: new ActisReporting('Add Unknown Vendor'),
  ASSESSOR_SECONDARY_LOGO: new ActisReporting('Clicked - Gartner logo in navbar'),
  APP_LAUNCHER: new ActisReporting('App Launcher'),
  HOME: new ActisReporting("Homepage"),
  BROWSE_VENDORS: new ActisReporting("Browse Vendors Visit"),
  IMPORT_VENDORS: new ActisReporting("Import  Vendors Visit"),
  ASSESSMENT_DASHBOARD: new ActisReporting("Assessment Dashboard Visit"),
  MANAGE_VENDORS: new ActisReporting("Manage Vendors Visit"),
  TEAM_ACTIVITY: new ActisReporting("Team Activity Visit"),
};
